<!-- eslint-disable -->
<template>
  <div class="datatable">
    <div class="datatable__actions">
      <div>
        <VsFormText v-model="userSearch" placeholder="Пошук" size="xs" icon="ti ti-search" />
      </div>
      <div class="flex items-center gap-2">
        <TableFormInput :value.sync="dataset" :input.sync="keysMeta" />
        <VsButton type="primary" size="mini" @click="opendAddForm"> Додати </VsButton>
      </div>
    </div>
    <div class="table-responsive datatable__table-inner">
      <table class="table table-bordered datatable__table w-full">
        <thead>
          <tr>
            <th>#</th>
            <th v-for="el in keysMeta" v-if="!el.hide" :key="el.name" :class="['datatable__head', el.type === 'Switcher' ? 'datatable__head--checkbox' : '']">
              {{ el.ua }}
            </th>
            <th class="datatable__head">Змінити</th>
          </tr>
        </thead>
        <Draggable v-if="dataset?.length" v-model="dataset" tag="tbody">
          <tr v-for="(row, i) in dataset" v-if="!row.hide" :key="dataset.key" class="datatable__row">
            <td>{{ i + 1 }}</td>
            <td v-for="el in keysMeta" v-if="!el.hide" :key="el.name" class="datatable__element">
              <VsFormCheckbox v-if="el.type === 'Switcher'" v-model="row[el.name]" />
              <div v-else>
                {{ row[el.name] || "-" }}
              </div>
            </td>
            <td class="datatable__element">
              <div class="datatable__element--actions">
                <VsPopover v-if="!isDialogVisible" placement="left" width="400">
                  <VsButton slot="reference" size="mini" @click="handleStartEdit(row)">
                    <i class="ti ti-pencil-minus"></i>
                  </VsButton>
                </VsPopover>
                <VsButton size="mini" @click="handleDelete(row)">
                  <i class="ti ti-trash"></i>
                </VsButton>
              </div>
            </td>
          </tr>
        </Draggable>
        <tbody v-else>
          <tr>
            <td colspan="100%">Немає даних</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="isDialogVisible">
      <VsDialog :visible.sync="dialog" :title="dialog === 'add' ? 'Додати елемент' : 'Редагувати елемент'">
        <slot name="form" :dialog="dialog" :form-data="newElement" :keys-meta="keysMeta" @submit="handleConfirm"></slot>
      </VsDialog>
    </div>
    <div v-if="dialog && isInline" class="datatable__inline">
      <p>{{ dialog === "add" ? "Додати елемент" : "Редагувати елемент" }}</p>
      <VsForm2 v-if="!formDataChnaged" :form-data="newElement" :form="{ components: keysMeta }" @submit="handleConfirm" @cancel="dialog = false" />
    </div>
  </div>
</template>
<script>
export default {
  components: {
    VsDialog: () => import('../../overlays/dialog/vs-dialog.vue'),
    VsPopover: () => import('../../tooltips/vs-popover.vue'),
    // VsForm2: () => import("../vs-form"),
    TableFormInput: () => import('./vs-form-datatable-input.vue'),
    VsButton: () => import('../../basic/vs-button.vue'),
    VsFormText: () => import('../vs-form-text.vue'),
    VsFormCheckbox: () => import('../vs-form-checkbox.vue'),
    Draggable: async () => {
      if (window.head) {
        await window.head.promise(['@/vendor/draggable/Sortable.min.js', '@/vendor/draggable/Sortable.min.js']);
        return window.vuedraggable;
      }
      return '';
    },
  },
  props: {
    openType: { type: String, default: 'dialog' }, // popover, dialog
    componentSettings: { type: Object, default: () => {} },
    value: { default: () => '' },
  },
  data() {
    return {
      userSearch: '',
      dialog: false,
      newElement: {},
      currentlyEditing: null,
      keysMeta: null,
      dataset: [],
      formDataChnaged: false,
    };
  },
  computed: {
    isInline() {
      return this.componentSettings?.inline || false;
    },
    isDialogVisible() {
      return this.dialog && this.openType === 'dialog';
    },
  },
  watch: {
    dataset: {
      handler(n) {
        this.$emit('change', n);
      },
      deep: true,
    },
    userSearch(n) {
      this.dataset?.forEach((el) => {
        el.hide = false;
        const hasSearchValues = Object.values(el).join('').toLowerCase().includes(n.toLowerCase());

        if (!hasSearchValues) {
          el.hide = true;
        }
      });
      this.dataset;
    },
    dialog(n) {
      if (!n) {
        this.newElement = {};
      }
    },
  },
  mounted() {
    const colModel = this.componentSettings.original?.colModel || this.componentSettings.colModel;

    this.keysMeta = colModel
      .filter((el) => el.type)
      .map((el) => ({
        ...el,
        key: el?.name || el.key,
        label: el.ua,
      }));
    this.dataset = this.value || [];
  },
  methods: {
    handleDelete(el) {
      this.dataset = this.dataset.filter((element) => element !== el);
    },
    opendAddForm() {
      this.dialog = 'add';
      this.renewForm();
    },
    renewForm() {
      if (this.isInline) {
        if (this.dialog === 'add') this.newElement = {};
        this.formDataChnaged = true;
        setTimeout(() => {
          this.formDataChnaged = false;
        }, 0);
      }
    },
    handleConfirm($event) {
      const { fieldsData } = $event;
      if (this.dialog === 'add') {
        this.dataset = this.dataset.concat(fieldsData);
      } else if (this.dialog === 'edit') {
        this.dataset = this.dataset.map((el) => {
          if (el === this.currentlyEditing) {
            el = fieldsData;
          }

          return el;
        });

        this.currentlyEditing = null;
      }
      this.dialog = false;
    },
    handleStartEdit(el) {
      this.newElement = JSON.parse(JSON.stringify(el));
      this.currentlyEditing = el;
      this.dialog = 'edit';
      this.renewForm();
    },
  },
};
</script>
<style lang="scss" scoped>
.datatable {
  &__head {
    font-size: 12px;
  }

  position: relative;
  &__table {
    border: 1px solid #ced4da;
    margin-bottom: 0 !important;
    &-inner {
      max-height: 70vh;
      overflow-y: scroll;

      &::-webkit-scrollbar {
        width: 7px;
        height: 7px;
        background-color: transparent;
      }

      &::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: #eaeaea;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #c2c2c2;
      }
    }

    thead {
      z-index: 999;
      border-color: #e4e7eb;
      border-bottom: none;
      position: sticky;
      top: 0;
    }

    th {
      border-color: #e4e7eb;
    }

    td {
      font-size: 12px;
    }

    &__cell {
      max-width: 200px;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    tr th:last-child {
      width: 90px;
    }

    tr td:last-child {
      width: 90px;
    }
  }

  &__actions {
    padding: 10px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 5px;
  }

  &__element--actions {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
  }

  &__head--checkbox {
    padding: 8px 0;
    word-break: break-word;
    max-width: 50px;
  }

  &__no-data {
    padding: 10px;
  }

  &__inline {
    margin-top: 20px;
  }
}
.el-dialog {
  padding: 15px;
}
</style>
